import {
  Component,
  ElementRef,
  Input,
  OnInit,
  OnChanges,
  SimpleChanges,
  ViewChild,
  AfterViewInit,
} from '@angular/core';
import { ChartConfiguration, ChartData, ChartType } from 'chart.js';
import { BaseChartDirective } from 'ng2-charts';

@Component({
    selector: 'app-statistics-chart',
    templateUrl: './statistics-chart.component.html',
    styleUrls: ['./statistics-chart.component.scss'],
    standalone: false
})
export class StatisticsChartComponent implements OnChanges, AfterViewInit {
  @ViewChild(BaseChartDirective) chart!: BaseChartDirective;

  @Input() muscleGroups: { muscle: string; value: number }[] = [];

  public barChartOptions: ChartConfiguration['options'] = {
    responsive: true,
    maintainAspectRatio: false, // Allow the chart to resize dynamically
    indexAxis: 'y', // This makes the bars horizontal
    scales: {
      x: {
        beginAtZero: true,
      },
      y: {
        ticks: {
          autoSkip: false, // Ensure all labels are displayed
          minRotation: 0, // Prevent label rotation
          maxRotation: 0, // Prevent label rotation
        },
      },
    },
    plugins: {
      legend: {
        display: false,
      },
      tooltip: {
        enabled: true, // Ensure tooltips are enabled
      },
    },
  };

  public barChartLabels: string[] = [];
  public barChartData: ChartData<'bar'> = {
    labels: this.barChartLabels,
    datasets: [{ data: [], label: 'Muscle Group Values' }],
  };
  public barChartType: ChartType = 'bar';

  constructor() {}

  ngOnChanges(changes: SimpleChanges) {
    if (changes['muscleGroups']) {
      this.updateChartData();
    }
  }

  ngAfterViewInit() {
    this.updateChartData();
  }

  updateChartData() {
    this.barChartLabels = this.muscleGroups.map((group) => group.muscle);
    this.barChartData = {
      labels: this.barChartLabels,
      datasets: [
        {
          data: this.muscleGroups.map((group) => group.value),
          label: 'Muscle Group Values',
          barThickness: 7, // Set a fixed bar thickness
          maxBarThickness: 20, // Optionally set a maximum bar thickness
          categoryPercentage: 0.8, // Adjust the category width
          barPercentage: 0.9, // Adjust the bar width within the category
        },
      ],
    };

    // Ensure chart height adjustment only if the view is initialized
    if (this.chart && this.chart.chart) {
      this.adjustChartHeight();
    }
  }

  adjustChartHeight() {
    const numberOfBars = this.muscleGroups.length;
    const barThickness = 13; // The bar thickness you set
    const padding = 50; // Add some padding for better appearance
    const chartHeight = numberOfBars * barThickness + padding;

    const chartContainer = document.querySelector(
      '.chart-container'
    ) as HTMLElement;

    if (chartContainer) {
      chartContainer.style.height = `${chartHeight}px`;
    }
    if (this.chart && this.chart.chart) {
      const chartCanvas = this.chart.chart.canvas;
      if (chartCanvas && chartCanvas.parentElement) {
        chartCanvas.parentElement.style.height = `${chartHeight}px`; // Set the canvas parent height
      }
    }
  }
}
